/* global $:false cob:false */

import { DEV_MODE } from './helpers/cob.devmode.js';

// # Cob.Utils
var utils = {};

utils.lpad = function(number, length, charToPadWith) {
    var str = String(number);
    charToPadWith = charToPadWith || 0;

    while (str.length < length) {
        str = charToPadWith + str;
    }

    return str;
};

utils.isNullOrEmpty = function(value) {
    return value === null || value === undefined || value === '';
};

utils.getEsFormattedFieldName = function(fieldName){
    const esSpecialCharsRegex = /[!/(){}[\]^"~*?:\\]/g;

    return fieldName.toLowerCase()
        .replace(/ /g, "_")
        .replace(esSpecialCharsRegex, "\\$1");
};

utils.time = {
    getDurationFromTimeStamp: function(timestamp) {
        var h = String(Math.floor(timestamp / 3600000));
        var m = String(Math.floor(timestamp / 60000 % 60));
        var s = String(Math.floor(timestamp / 1000 % 60));

        return ( h.length === 1 ? '0' + h : h) + ":" +
               ( m.length === 1 ? '0' + m : m) + ":" +
               ( s.length === 1 ? '0' + s : s);
    },

    getLocalDateFromTimeStamp: function(timestamp, locale) {
        const date = new Date(timestamp);
        return new Intl.DateTimeFormat(locale, {dateStyle: 'short'}).format(date)
    },

    getLocalDateTimeFromTimeStamp: function(timestamp, locale) {
        const date = new Date(timestamp);
        return new Intl.DateTimeFormat(locale, {dateStyle: 'short', timeStyle: 'short'}).format(date)
    },

    // Estes getUTC* só são usados no ConfM, se bem que não percebo muito bem porquê
    getUTCDateFromTimeStamp: function(timestamp) {
        var date = new Date(timestamp);

        var d = String(date.getUTCDate());
        var m = String(date.getUTCMonth() + 1);
        var y = String(date.getUTCFullYear());
        return ( d.length === 1 ? '0' + d : d) + "/" +
               ( m.length === 1 ? '0' + m : m) + "/" + y;
    },
    getUTCTimeFromTimeStamp: function(timestamp) {
        var date = new Date(timestamp);

        var h = String(date.getUTCHours());
        var m = String(date.getUTCMinutes());
        var s = String(date.getUTCSeconds());
        return ( h.length === 1 ? '0' + h : h) + ":" +
               ( m.length === 1 ? '0' + m : m) + ":" +
               ( s.length === 1 ? '0' + s : s);
    },
    getUTCDateTimeFromTimeStamp: function(timestamp) {
        return this.getUTCDateFromTimeStamp(timestamp) + " " + this.getUTCTimeFromTimeStamp(timestamp);
    }

};

utils.numbers = {
    //Checks if a given argument is an integer
    isInt: function(number) {
        return !isNaN(number) && parseFloat(number) == parseInt(number, 10);
    },

    format: function(number, decimalPlaces, _thousandSeparator, _decimalSeparator, autoDetectIntegers) {
        const locale = (typeof cob.app !== 'undefined') ? cob.app.getLocale() : 'pt';

        const message = "DEPRECATED: utils.numbers.format is deprecated" +
            " and should be switched to utils.numbers.formatWithLocale";

        window.console.warn(message);
        /* eslint-disable-next-line  */
        if(typeof Sentry !== 'undefined') Sentry.captureMessage(message);

        return utils.numbers.formatWithLocale(number, locale, decimalPlaces, autoDetectIntegers);
    },

    //formats a number with the specified parameters
    // if `autoDetectIntegers` is true then there will be no decimal places if the number is an int
    formatWithLocale: function(number, locale, decimalPlaces, autoDetectIntegers) {
        var decPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;

        if(autoDetectIntegers && utils.numbers.isInt(number)){
            decPlaces = 0;
        }

        return Number(number).toLocaleString(locale, {
           minimumFractionDigits: decPlaces,
           maximumFractionDigits: decPlaces
        })
    }
};


// ## cob.utils.CountdownLatch
//
// A simple way to wait for a series of _async_ operations to end.
// Has a `countDown` function that should be passed as a callback to all the operations.
// When that function has been called the same number of times as the `times` parameter,
// it will execute the `callback` function.
// Adicional callbacks can be added with the `addCallback` function, **even if the Latch as already reached zero**.
// In that case, it will trigger the callback immediately.
//
// times: the number of times that the `countDown` function should be called before triggering the `callback`.
//
// callback: the function to be executed when the latch reaches 0.
//
// name: a name for the callback. Optional and only used for logging.
utils.CountdownLatch = function(times, callback, name) {

    //if we have a name use it, else let's just use something
    var _name = name || "anonymous",
        _times = times,
        _callbacks = [];

    var _safeAddCallback = function(fn) {
        if (fn && typeof fn === 'function') {
            _callbacks.push(fn);
        }
    };

    // This should be called once for every operation that completes.
    //
    // why: optional param useful for logging, to be able to tell who called us
    this.countDown = function(why) {
        _times -= 1;

        //If we were given a reason, log it
        if (why) {
            DEV_MODE && window.console.log("LATCH(" + _name + ") decremented to " + _times + ' because ' + why);
        } else {
            DEV_MODE && window.console.log("LATCH(" + _name + ") decremented to " + _times);
        }

        // If we reached 0 and have a callback, call it!
        if (_times === 0 && _callbacks.length > 0) {
            for (var i = 0; i < _callbacks.length; i++) {
                _callbacks[i]();
            }
        }
    };

    // This can be called to add aditional callbacks to the Latch.
    // If the Latch is still active, they'll be triggered when it reaches zero.
    // If the Latch is already at zero, they'll be triggered immediately.
    //
    // fn: the new callback
    this.addCallback = function(fn) {
        if (_times > 0) {
            _safeAddCallback(fn);
        } else {
            if (fn && typeof fn === 'function') fn();
        }
    };

    DEV_MODE && window.console.log("LATCH(" + _name + "): counting down from " + _times);

    this.addCallback(callback);
};

// ## cob.utils.ZeroLatch
//
// A way to trigger events when **entering** and **leaving** a _zero state_.
// It starts at the _zero state_ and leaves it when `increment` is called,
// returning to the _zero state_ when `decrement` has been called an **equal**
// number of times.
//
// It is used to control showing and hiding the global loading indicator.
//
// nonZeroCallBack: callback triggered when **leaving** the _zero state_
// zeroCallBack: callback triggered when **returning** to the _zero state_
// name: the optional name to use for logging
utils.ZeroLatch = function(nonZeroCallBack, zeroCallBack, name) {
    var numActive = 0,
        _name = name || "anonymous",
        numInteractions = 0;

    DEV_MODE && window.console.log("Initializing ZeroLatch " + _name);

    return {
        increment: function(why) {
            numActive += 1;

            numInteractions++;
            DEV_MODE && window.console.log(
                "ZeroLatch(" + _name + ")" + numInteractions + ": incrementing to " + numActive + " because of " + why
            );

            // we trigger when **leaving** the _zero state_
            if (numActive === 1) nonZeroCallBack();
        },
        decrement: function(why) {
            numActive -= 1;

            numInteractions++;
            DEV_MODE && window.console.log(
                "ZeroLatch(" + _name + ")" + numInteractions + " decrementing to " + numActive + " because of " + why
            );

            // we trigger when **returning** to the _zero state_
            if (numActive === 0) zeroCallBack();
        },
        reset: function(why) {
            numActive = 0;

            DEV_MODE && window.console.log(
                "ZeroLatch(" + _name + ")" + numInteractions + " resetting because of " + why
            );

            zeroCallBack();
        }
    };
};

// ## cob.utils.delayed
//
// Convenience function useful when we want to call another function after a delay.
// The `delay` param is optional and defaults to 300ms.
utils.delayed = function(fn, delay) {
    var _delay = delay || 300;

    window.setTimeout(fn, _delay);
};

// ## cob.utils.forEachOwn
//
// Calls a function on all of the object's own properties, as decided by `hasOwnProperties`.
//
// Instead of:
//
//      for(prop in object){
//        if(object.hasOwnProperty(prop))
//          doSomethingWith(prop);
//      }
// You can use:
//
//      cob.utils.forEachOwn(object, doSomethingWith(prop));
//
utils.forEachOwn = function forEachOwn(o, callback) {
    var prop;

    for (prop in o) if (o.hasOwnProperty(prop)) callback(prop);
};

// ## cob.utils.extend
//
// A little util function that copies properties from one object to the other.
// Only copies "own properties" and by default doesn't override existing ones. It's very _naive_ and will
// probably fail in corner cases. We just dont want to use a _lib_ if we can help it.
//
// target: the target object
// source: the source object
// override: if truthy, we'll override existing properties
utils.extend = function(target, source, override) {

    utils.forEachOwn(source, function(prop) {
        // we don't override existing properties
        if (!override && target[prop] !== undefined) {
            window.console.trace("Tried to override a property named \"" + prop + "\" on " + target);

        } else {
            target[prop] = source[prop];
        }
    });
};

// ## cob.utils.clone
//
// Clones and returns a new json object
//
// It uses the json stringify, to create a string that represents the original, and
// then the parse method to build a new object from that string.
//
// For more info see: http://www.json.org/js.html
//
utils.clone = function(json) {

    // Use the native stringify version to create a string representing the json object.
    //
    // A json object is a lightweight data-interchange format. It doesn't support functions.
    // So the default behaviour of the stringify method ignores it.
    //
    // By providing a replacer I can create a representation when the value of the property is a function.
    var jsonText = JSON.stringify(json, function(_key, value) {

        // When the value of the property is a function return the content as a string
        if (typeof (value) === "function") {
            return String(value);
        }

        return value;
    });

    // The parse method also support a declaration of a reviver function that can help
    // build a json representation of a value.
    //
    // We use this mechanism to build a function from the string representation
    return JSON.parse(jsonText, function(_key, value) {

        if (value && typeof value === "string") {

            // Handle the creation of a function using the Function object.
            if (value.match(/^function.*/g)) {
                /* eslint-disable-next-line no-new-func */
                return (new Function("return " + value))();
            }
        }

        return value;
    });
};

utils.loadResource = function(opts) {
    var defaults = {
        cache: true,
        method: 'get',
        dataType: 'text',

        error: function(req, _status, error) {
            window.console.error("APP:ERROR: Error loading resource " + opts.url + ": " + req.status +
                               " : " + req.statusText + " : " + error);
        }
    };

    // we override our defaults with opts
    utils.extend(defaults, opts, true);

    DEV_MODE && window.console.log("APP:loading resource: " + defaults.url);

    $.ajax(defaults);
};

// ## cob.utils.userSession
//
// Returns information associated to the user session.
utils.userSession = {
    getProtocol: function() {
        return window.location.protocol
    },
    getHost: function() {
        return window.location.host;
    },
    getQueryParameter: function(queryParamName){
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(queryParamName);
    }
};

// ## cob.utils.encodeHTML
//
// Makes a string safe for including in HTML
utils.encodeHTML = function(str) {
    return $('<span>').text(str).html();
};

//Return the formatted product name to show in the specific search results
utils.getProductDisplayName = function(core, productName) {
    var _product = "";

    var products = core.getCustomInfo("products");

    if(products === undefined || products.length === 0){
        throw new Error("NO PRODUCTS DEFINED - there must exist at least one custom-info.products property " +
            "in the file com.cultofbits.web.integration.properties");
    }

    products.some(function(product) {
        if (product.key === productName) {
            _product = product.value;
            return true
        }
    });

    return _product;
};

export default utils;
